import React from "react";
import styles from "../Input/TextField/TextField.module.css";
import { labelName } from "../../utils";

export default function BodyEl({ title, body }) {
  return (
    <p
      className="field-group"
      title={title}
      dangerouslySetInnerHTML={{__html: body}}
    />
  );
}
